export const PRODUCT_LICENSES_FETCHING = 'PRODUCT_LICENSES_FETCHING';
export const PRODUCT_LICENSES_FETCHED = 'PRODUCT_LICENSES_FETCHED';
export const PRODUCT_LICENSES_FETCH_ERROR = 'PRODUCT_LICENSES_FETCH_ERROR';



// WEBPACK FOOTER //
// ./src/state/product/types.js